/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-duplicates */
import React, {
  useEffect,
  useState,
  useCallback,
  useMemo,
  useRef,
} from 'react';

import { useHistory } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { format, parseISO, isSameDay } from 'date-fns';
import _ from 'lodash';
import { Button, Col, Row, Card } from 'react-bootstrap';

import {
  FaCheckCircle,
  FaRegQuestionCircle,
  FaRegMoneyBillAlt,
  FaRegThumbsUp,
  FaRegCalendarCheck,
  FaRegMinusSquare,
  FaRegPlusSquare,
  FaBan,
  FaIdCard,
  FaRegHospital,
  FaRedo,
  FaMoneyBillAlt,
  FaMoneyBill,
} from 'react-icons/fa';
import { useAuth } from '../../hooks/auth';

import { useToast } from '../../hooks/toast';
import api from '../../services/api';
import {
  formatPrice,
  TIPO_USUARIO,
  updateTimeToNow,
} from '../../utils/funcoes';

import Pagamento from '../../components/Pagamento';
import Modal from '../../components/Modal';
import Input from '../../components/Input';
import InputFake from '../../components/InputFake';
import Loading from '../../components/Loading';

import { ORIGEM_PAGAMENTO, STATUS_AGENDA } from '../../utils/funcoes';

import { Container, ContainerPago, Pago, HeaderCaixa } from './styles';
import IDadosAgendamento from '../../components/Pagamento/IDadosAgendamento';
import getResponseErrors from '../../utils/getResponseErrors';
import socket from '../../services/socket';
import { useClinica } from '../../hooks/clinica';

interface ISangriaTroco {
  CprHistorico: string;
  CprCodigo: number;
  CprOrigem: number;
  CprDataOrigem: Date;
  CprValor: number;
  ehSangria?: boolean;
  hora?: string;
  valorFormatado?: string;
}

interface IIcons {
  [key: string]: JSX.Element;
}

const icons: IIcons = {
  ban: <FaBan size={15} className="mb-2" />,
  question: <FaRegQuestionCircle size={15} className="mb-2" />,
  check: <FaCheckCircle size={15} className="mb-2" />,
  money: <FaRegMoneyBillAlt size={15} className="mb-1" />,
  card: <FaIdCard size={15} className="mb-2" />,
  thumbs: <FaRegThumbsUp size={15} className="mb-2" />,
  calendar: <FaRegCalendarCheck size={15} className="mb-2" />,
  hospital: <FaRegHospital size={15} className="mb-2" />,
  troco: <FaMoneyBillAlt size={19} className="mb-1" />,
  sangria: <FaMoneyBill size={19} className="mb-1" />,
};

const Caixa: React.FC = () => {
  const { user } = useAuth();
  const history = useHistory();
  const formRefSenha = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const { dataHoraServidor } = useClinica();

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.ATENDENTE_CAIXA) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const [loading, setLoading] = useState(false);
  const [showModalSenha, setShowModalSenha] = useState(false);
  const [autenticado, setAutenticado] = useState(false);
  const [agendamentosHoje, setAgendamentosHoje] = useState<IDadosAgendamento[]>(
    [],
  );
  const [sangriaTroco, setSangriaTroco] = useState<ISangriaTroco[]>([]);
  const [agendamentosEncaminhados, setAgendamentosEncaminhados] = useState<
    IDadosAgendamento[]
  >([]);

  const [pagamentoSelecionado, setPagamentoSelecionado] = useState<
    IDadosAgendamento | undefined
  >(undefined);
  const [sangriaTrocoSelecionado, setSangriaTrocoSelecionado] = useState<
    number | undefined
  >(undefined);
  const [showModalPagamento, setShowModalPagamento] = useState(false);
  const [tituloPagamento, setTituloPagamento] = useState(
    'Pagar Consulta/Exame',
  );
  const [tipoPagamento, setTipoPagamento] = useState(ORIGEM_PAGAMENTO.DESPESA);

  useEffect(() => {
    const handleNewMessage = (dados: IDadosAgendamento): void => {
      setAgendamentosEncaminhados(state => {
        return state ? state.concat([dados]) : [dados];
      });
    };

    socket.on('encaminhado_caixa', handleNewMessage);
    return () => {
      socket.removeEventListener('encaminhado_caixa', handleNewMessage);
    };
  }, []);

  const loadDados = useCallback(async (): Promise<void> => {
    setLoading(true);
    try {
      const response = await api.get<IDadosAgendamento[]>(
        `caixa/agendamentosEncaminhados`,
      );

      const agendas = response.data.map(agenda => {
        const horaIni = format(parseISO(agenda.AgeInicio.toString()), 'HH:mm');
        const horaFim = format(parseISO(agenda.AgeFim.toString()), 'HH:mm');

        const consultaDoDia = isSameDay(
          parseISO(agenda.AgeInicio.toString()),
          updateTimeToNow(new Date(dataHoraServidor.toString())),
        );

        const pagamentoAntecipado =
          agenda.AgeStatus === STATUS_AGENDA.PAGAMENTO_ANTECIPADO;

        return {
          ...agenda,
          horaIni,
          horaFim,
          consultaDoDia,
          pagamentoAntecipado,
        };
      });
      const agendasPagas = agendas.filter(
        agenda => agenda.AgeStatus !== STATUS_AGENDA.ENCAMINHADO_CAIXA,
      );

      const agendasAPagar = _.difference(agendas, agendasPagas);

      setAgendamentosEncaminhados(agendasAPagar);
      setAgendamentosHoje(agendasPagas);
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível carregar agendamentos encaminhados',
        type: 'error',
        description: mensagemErro,
      });
      setAgendamentosEncaminhados([]);
      setAgendamentosHoje([]);
    }
    try {
      const responseSangriaTroco = await api.get<ISangriaTroco[]>(
        `pagamento/sangriatroco?codClinica=${
          user.UsuClinica
        }&data=${updateTimeToNow(new Date(dataHoraServidor.toString()))}`,
      );

      const sangriasTrocos = responseSangriaTroco.data.map(st => {
        const hora = format(parseISO(st.CprDataOrigem.toString()), 'HH:mm');
        return {
          ...st,
          hora,
          ehSangria: st.CprOrigem === ORIGEM_PAGAMENTO.SANGRIA,
          valorFormatado: formatPrice(st.CprValor),
        };
      });
      setSangriaTroco(sangriasTrocos);
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível carregar dados de sangria e troco',
        type: 'error',
        description: mensagemErro,
      });
      setSangriaTroco([]);
    }
    setLoading(false);
  }, [addToast, user.UsuClinica, dataHoraServidor]);

  useEffect(() => {
    setShowModalSenha(!autenticado);
    if (autenticado) {
      loadDados();
    }
  }, [loadDados, autenticado]);

  const totais = useMemo(() => {
    const totalAgendamentos = [
      ...agendamentosHoje,
      ...agendamentosEncaminhados,
    ];
    const plano = totalAgendamentos.filter(
      agendamento => agendamento.AgePlano === 1,
    );

    const total = totalAgendamentos.length;
    const totalPlano = plano.length;
    const totalParticular = total - totalPlano;

    return { total, totalPlano, totalParticular };
  }, [agendamentosEncaminhados, agendamentosHoje]);

  const handleAutenticar = useCallback(
    async data => {
      setLoading(true);
      try {
        const dados = {
          UsuLogin: user.UsuEmail,
          UsuSenha: data.password,
        };
        await api.post(`users/validacaixa`, dados);

        setShowModalSenha(false);
        setAutenticado(true);
      } catch (err) {
        addToast({ type: 'error', title: 'Usuário ou senha Inválidos' });
      } finally {
        setLoading(false);
      }
    },
    [addToast, user.UsuEmail],
  );

  const handlePagamento = useCallback(
    (
      titulo: string,
      tpPagamento: number,
      pagamento: IDadosAgendamento | undefined,
    ) => {
      setTituloPagamento(titulo);
      setTipoPagamento(tpPagamento);
      if (pagamento) {
        setPagamentoSelecionado(pagamento);
      }

      setShowModalPagamento(true);
    },
    [],
  );

  const handleTrocoSangria = useCallback(
    (titulo: string, tpPagamento: number, cprCodigo: number | undefined) => {
      setTituloPagamento(titulo);
      setTipoPagamento(tpPagamento);
      if (cprCodigo) {
        setSangriaTrocoSelecionado(cprCodigo);
      }

      setShowModalPagamento(true);
    },
    [],
  );

  const handleFecharModalPagamento = useCallback(
    async (load: boolean, mantemModalAberto?: boolean) => {
      if (!mantemModalAberto) {
        setShowModalPagamento(false);
        setPagamentoSelecionado(undefined);
      }
      setSangriaTrocoSelecionado(undefined);
      if (load) {
        setLoading(true);
        await loadDados();
        setLoading(false);
      }
    },
    [loadDados, setLoading],
  );

  return (
    <>
      {showModalSenha && (
        <Modal
          show={showModalSenha}
          titulo="Digite a senha novamente"
          handleFecharModal={
            () =>
              addToast({
                type: 'info',
                title: 'não é possivel fechar esta janela sem autenticar',
              })
            // eslint-disable-next-line react/jsx-curly-newline
          }
          large={false}
        >
          <Form ref={formRefSenha} onSubmit={handleAutenticar}>
            <InputFake value={user.UsuEmail} label="E-mail" />
            <Input
              label="Senha"
              name="password"
              type="password"
              containerStyle={{ maxWidth: '200px' }}
            />
            <div className="d-flex justify-content-end">
              <Button type="submit" className="mt-2" size="sm">
                Autenticar
              </Button>
            </div>
          </Form>
        </Modal>
      )}

      {showModalPagamento && (
        <Modal
          show={showModalPagamento}
          titulo={tituloPagamento}
          handleFecharModal={() => handleFecharModalPagamento(false)}
        >
          <Pagamento
            handleFechar={handleFecharModalPagamento}
            tipo={tipoPagamento.toString()}
            cprCodigo={
              pagamentoSelecionado?.CprCodigo || sangriaTrocoSelecionado
            }
            pacCodigo={pagamentoSelecionado?.PacCodigo}
          />
        </Modal>
      )}
      <Row noGutters>
        <Col md="2">
          <ContainerPago>
            <div className="p-2">
              <h5 className="text-secondary">Pagamentos do Dia</h5>
              <span>
                Particular: {totais.totalParticular}
                <br />
                Cartão Saúde: {totais.totalPlano}
                <br />
                <br />
                <span className="text-primary">
                  <b>Total Caixa: {totais.total}</b>
                </span>
              </span>
              <br />
              <br />
            </div>
            <ul key="AgendasPagas" className="list-group list-group-flush">
              {agendamentosHoje.length > 0 &&
                agendamentosHoje.map(agendamento => {
                  return (
                    <Pago
                      key={agendamento.AgeCodigo.toString()}
                      ehPagamentoAntecipado={
                        !agendamento.consultaDoDia ||
                        agendamento.pagamentoAntecipado
                      }
                      className="list-group-item py-2"
                      title={
                        !agendamento.consultaDoDia ||
                        agendamento.pagamentoAntecipado
                          ? 'Pagamento Antecipado'
                          : ''
                      }
                      onClick={
                        () =>
                          handlePagamento(
                            `Consulta/Exame - ${agendamento.ConNome} - ${agendamento.horaIni}`,
                            ORIGEM_PAGAMENTO.CONSULTAS,
                            agendamento,
                          )
                        // eslint-disable-next-line react/jsx-curly-newline
                      }
                    >
                      <p>
                        {!agendamento.consultaDoDia ||
                        agendamento.pagamentoAntecipado
                          ? icons.calendar
                          : ''}
                        <b>
                          {' '}
                          {agendamento.horaIni} - {agendamento.horaFim}
                        </b>{' '}
                        - {agendamento.AgeStatus > 3 ? icons.thumbs : ' '}
                        {agendamento.AgePlano === 1 ? icons.card : ''}
                      </p>
                      {agendamento.PacNomeSocial.trim() !== '' ? (
                        <span className="small">
                          Nome Social: <b>{agendamento.PacNomeSocial}</b>
                        </span>
                      ) : (
                        <span className="small">{agendamento.PacNome}</span>
                      )}
                    </Pago>
                  );
                })}
            </ul>
          </ContainerPago>
        </Col>
        <Col md="8">
          <Container className="mt-0" style={{ minHeight: '90vh' }}>
            <div className="d-flex">
              <h4 className="text-muted text-left mr-3">
                Pacientes Encaminhados para o Caixa
              </h4>
              <a href="#" onClick={loadDados}>
                <FaRedo size="30" />
              </a>
            </div>
            {loading && <Loading backgroundBlack={false} />}

            {agendamentosEncaminhados.length > 0 &&
              agendamentosEncaminhados.map(agendamento => {
                return (
                  <Card
                    key={`card${agendamento.AgeCodigo}`}
                    className={`${
                      !agendamento.consultaDoDia ? 'bg-primary' : 'bg-info'
                    } text-white m-2`}
                    role="button"
                    onClick={
                      () =>
                        handlePagamento(
                          `Pagar Consulta/Exame - ${agendamento.ConNome} - ${agendamento.horaIni}`,
                          ORIGEM_PAGAMENTO.CONSULTAS,
                          agendamento,
                        )
                      // eslint-disable-next-line react/jsx-curly-newline
                    }
                  >
                    <Card.Body className="py-2">
                      <Card.Text>
                        <span>
                          {agendamento.ConNome} {agendamento.horaIni} -{' '}
                          {agendamento.horaFim}{' '}
                        </span>{' '}
                        -{' '}
                        {!agendamento.consultaDoDia
                          ? 'Pagamento Antecipado ' && icons.calendar
                          : 'Encaminhado Caixa'}{' '}
                        {icons.money}
                        <br />
                        {agendamento.PacNomeSocial.trim() !== '' ? (
                          <span>
                            Nome Social:{' '}
                            <b>
                              {agendamento.PacNomeSocial}
                              {agendamento.AgeObs !== ''
                                ? ` - ${agendamento.AgeObs}`
                                : ''}
                            </b>
                          </span>
                        ) : (
                          <b>
                            {agendamento.PacNome}
                            {agendamento.AgeObs !== ''
                              ? ` - ${agendamento.AgeObs}`
                              : ''}
                          </b>
                        )}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                );
              })}
          </Container>
        </Col>
        <Col md="2">
          <ContainerPago className="mr-0">
            <HeaderCaixa>
              <Button
                type="button"
                variant="outline-secondary"
                size="sm"
                onClick={
                  () =>
                    handlePagamento(
                      'Inserir Sangria',
                      ORIGEM_PAGAMENTO.SANGRIA,
                      undefined,
                    )
                  // eslint-disable-next-line react/jsx-curly-newline
                }
              >
                <FaRegMinusSquare size="15" /> Sangria
              </Button>
              <Button
                type="button"
                variant="outline-secondary"
                size="sm"
                onClick={
                  () =>
                    handlePagamento(
                      'Inserir Troco',
                      ORIGEM_PAGAMENTO.TROCO,
                      undefined,
                    )
                  // eslint-disable-next-line react/jsx-curly-newline
                }
              >
                <FaRegPlusSquare size="15" /> Troco
              </Button>

              <Button
                type="button"
                variant="outline-secondary"
                size="sm"
                onClick={
                  () =>
                    handlePagamento(
                      'Inserir Despesa',
                      ORIGEM_PAGAMENTO.DESPESA,
                      undefined,
                    )
                  // eslint-disable-next-line react/jsx-curly-newline
                }
              >
                <FaRegMinusSquare size="15" /> Despesa
              </Button>
            </HeaderCaixa>

            <ul key="TrocosSangrias" className="list-group list-group-flush">
              {sangriaTroco.length > 0 &&
                sangriaTroco.map(sT => {
                  return (
                    <Pago
                      key={sT.CprCodigo}
                      className="list-group-item py-2  text-right"
                      ehSangria={sT.ehSangria}
                      onClick={
                        () =>
                          handleTrocoSangria(
                            sT.CprHistorico,
                            sT.CprOrigem,
                            sT.CprCodigo,
                          )
                        // eslint-disable-next-line react/jsx-curly-newline
                      }
                    >
                      <p>
                        <b>
                          {sT.valorFormatado} - {sT.hora} h
                        </b>{' '}
                        - {sT.ehSangria ? icons.sangria : icons.troco}
                      </p>
                      <span className="small">{sT.CprHistorico}</span>
                    </Pago>
                  );
                })}
            </ul>
          </ContainerPago>
        </Col>
      </Row>
    </>
  );
};

export default Caixa;
